export enum EligibilityEnum {
  ALL = 'all',
  RANKS = 'ranks',
  SEGMENT = 'segment',
}
